import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import Vue from 'vue';
import * as filters from './filter';
Object.keys(filters).forEach(function (key) {
  Vue.filter(key, filters[key]);
});